/* ==========================================================================
   sdp-program.js — Stress Digital Product: program reader
   Day switching (#day-N), mobile day drawer, completion + progress.
   Access and drip are decided server-side in sections/sdp-program.liquid;
   nothing here can unlock content that Liquid did not render.
   ========================================================================== */
(function () {
  'use strict';

  function readDone(key) {
    try {
      var raw = window.localStorage.getItem(key);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function writeDone(key, list) {
    try {
      window.localStorage.setItem(key, JSON.stringify(list));
    } catch (e) {
      /* private mode / quota — progress just won't persist */
    }
  }

  // GA4 — sdp-analytics.js owns the schema and the design-mode guard; this is
  // just a safe hand-off so the reader still works if that file is missing.
  function emit(name, params) {
    params = params || {};
    params.section = params.section || 'reader';
    try {
      if (typeof window.SDPTrack === 'function') window.SDPTrack(name, params);
    } catch (e) {}
  }

  function emitOnce(key, name, params) {
    params = params || {};
    params.section = params.section || 'reader';
    try {
      if (typeof window.SDPTrackOnce === 'function') window.SDPTrackOnce(key, name, params);
    } catch (e) {}
  }

  function init(root) {
    var indexEl = root.querySelector('[data-sdpp-index]');
    if (!indexEl) return;

    var days = [];
    try {
      days = JSON.parse(indexEl.textContent) || [];
    } catch (e) {
      return;
    }
    if (!days.length) return;

    var storageKey = root.getAttribute('data-storage-key') || 'sdpp';
    var total = parseInt(root.getAttribute('data-total-days'), 10) || days.length;
    var weekWord = root.getAttribute('data-week-word') || 'Week';
    var dayWord = root.getAttribute('data-day-word') || 'Day';

    var panes = root.querySelectorAll('[data-sdpp-pane]');
    var links = root.querySelectorAll('[data-sdpp-day]');
    var prevBtn = root.querySelector('[data-sdpp-prev]');
    var nextBtn = root.querySelector('[data-sdpp-next]');
    var toggle = root.querySelector('[data-sdpp-toggle]');
    var scrim = root.querySelector('[data-sdpp-scrim]');
    var numEl = root.querySelector('[data-sdpp-current-num]');
    var weekEl = root.querySelector('[data-sdpp-current-week]');
    var titleEl = root.querySelector('[data-sdpp-current-title]');
    var fillEl = root.querySelector('[data-sdpp-progress-fill]');
    var pctEl = root.querySelector('[data-sdpp-progress-pct]');
    var completeBtns = root.querySelectorAll('[data-sdpp-complete]');
    var completeLabel = root.getAttribute('data-complete-label') || 'Complete lesson';
    var completedLabel = root.getAttribute('data-completed-label') || 'Lesson completed';

    var current = 0;

    function dayAt(i) {
      for (var n = 0; n < days.length; n++) {
        if (days[n].i === i) return days[n];
      }
      return null;
    }

    // Drop anything stored for days this program no longer has — a week that
    // lost days would otherwise keep counting toward the total, and the bar
    // could read past 100%.
    var done = readDone(storageKey).filter(function (i, at, list) {
      return dayAt(i) !== null && list.indexOf(i) === at;
    });
    if (done.length !== readDone(storageKey).length) writeDone(storageKey, done);

    function firstOpenDay() {
      // The furthest unlocked day the customer has not finished yet.
      for (var n = 0; n < days.length; n++) {
        if (!days[n].locked && done.indexOf(days[n].i) === -1) return days[n].i;
      }
      for (var m = days.length - 1; m >= 0; m--) {
        if (!days[m].locked) return days[m].i;
      }
      return days[0].i;
    }

    // Bonus days sit outside the progress bar: `total` is the core program, so
    // the denominator reads the same whether or not the upsell was bought.
    function baseDone() {
      var count = 0;
      for (var n = 0; n < done.length; n++) {
        var d = dayAt(done[n]);
        if (d && !d.bonus) count++;
      }
      return count;
    }

    function renderProgress() {
      var pct = total > 0 ? Math.floor((baseDone() / total) * 100) : 0;
      if (pct > 100) pct = 100;
      if (fillEl) fillEl.style.width = pct + '%';
      if (pctEl) pctEl.textContent = pct + '%';
    }

    function renderTicks() {
      for (var n = 0; n < links.length; n++) {
        var li = parseInt(links[n].getAttribute('data-sdpp-day'), 10);
        links[n].classList.toggle('is-done', done.indexOf(li) !== -1);
      }
      for (var b = 0; b < completeBtns.length; b++) {
        var btn = completeBtns[b];
        var isDone = done.indexOf(parseInt(btn.getAttribute('data-sdpp-complete'), 10)) !== -1;
        var text = btn.querySelector('[data-sdpp-complete-text]');
        btn.classList.toggle('is-done', isDone);
        btn.setAttribute('aria-pressed', isDone ? 'true' : 'false');
        if (text) text.textContent = isDone ? completedLabel : completeLabel;
      }
    }

    // The only thing that completes a day. Clicking a completed day un-completes
    // it, so a mis-tap is recoverable; locked days have no button to press.
    function setDone(i, on) {
      var day = dayAt(i);
      if (!day || day.locked) return;
      var at = done.indexOf(i);
      if (on === (at !== -1)) return;
      if (on) {
        done.push(i);
      } else {
        done.splice(at, 1);
      }
      writeDone(storageKey, done);
      renderTicks();
      renderProgress();

      if (on) {
        emitOnce('day_done:' + i, 'day_complete', {
          day: i, week: day.w, label: day.t, value: done.length
        });
        if (baseDone() >= total) {
          emitOnce('program_done', 'program_complete', { value: total });
        }
      } else {
        emit('day_uncomplete', { day: i, week: day.w, label: day.t, value: done.length });
      }
    }

    function closeDrawer() {
      root.classList.remove('is-drawer-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      if (scrim) scrim.hidden = true;
    }

    function openDrawer() {
      root.classList.add('is-drawer-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      if (scrim) scrim.hidden = false;
    }

    function show(i, push) {
      var day = dayAt(i);
      if (!day) return;
      current = i;

      var n;
      for (n = 0; n < panes.length; n++) {
        panes[n].hidden = parseInt(panes[n].getAttribute('data-sdpp-pane'), 10) !== i;
      }

      for (n = 0; n < links.length; n++) {
        var li = parseInt(links[n].getAttribute('data-sdpp-day'), 10);
        links[n].classList.toggle('is-active', li === i);
      }
      renderTicks();

      if (numEl) numEl.textContent = String(day.i);
      if (weekEl) weekEl.textContent = weekWord + ' ' + day.w;
      if (titleEl) titleEl.textContent = dayWord + ' ' + day.i + ': ' + day.t;

      if (prevBtn) prevBtn.disabled = !dayAt(i - 1);
      if (nextBtn) nextBtn.disabled = !dayAt(i + 1);

      renderProgress();

      emit(day.locked ? 'day_locked_view' : 'day_open', {
        day: day.i, week: day.w, label: day.t
      });

      if (push && window.history && window.history.replaceState) {
        window.history.replaceState(null, '', '#day-' + i);
      }
    }

    function fromHash() {
      var m = /^#day-(\d+)$/.exec(window.location.hash || '');
      return m ? parseInt(m[1], 10) : 0;
    }

    // ---- wiring ----
    for (var n = 0; n < links.length; n++) {
      (function (link) {
        link.addEventListener('click', function (e) {
          var i = parseInt(link.getAttribute('data-sdpp-day'), 10);
          if (link.classList.contains('is-locked')) {
            e.preventDefault();
            var locked = dayAt(i);
            emit('locked_day_click', {
              day: i, week: locked ? locked.w : null, label: locked ? locked.t : null
            });
            return;
          }
          e.preventDefault();
          emit('day_nav', { action: 'day_nav', label: 'sidebar', day: i });
          show(i, true);
          closeDrawer();
          window.scrollTo(0, 0);
        });
      })(links[n]);
    }

    for (var c = 0; c < completeBtns.length; c++) {
      (function (btn) {
        btn.addEventListener('click', function () {
          var i = parseInt(btn.getAttribute('data-sdpp-complete'), 10);
          setDone(i, done.indexOf(i) === -1);
        });
      })(completeBtns[c]);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (dayAt(current - 1)) {
          emit('day_nav', { action: 'day_nav', label: 'previous', day: current - 1 });
          show(current - 1, true);
          window.scrollTo(0, 0);
        }
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (dayAt(current + 1)) {
          emit('day_nav', { action: 'day_nav', label: 'next', day: current + 1 });
          show(current + 1, true);
          window.scrollTo(0, 0);
        }
      });
    }
    if (toggle) {
      toggle.addEventListener('click', function () {
        if (root.classList.contains('is-drawer-open')) {
          closeDrawer();
        } else {
          openDrawer();
          emit('days_drawer_open', { label: 'days_button' });
        }
      });
    }
    if (scrim) scrim.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    window.addEventListener('hashchange', function () {
      var i = fromHash();
      if (i && i !== current) show(i, false);
    });

    emitOnce('program_view', 'program_view', {
      value: parseInt(root.getAttribute('data-unlocked'), 10) || 0,
      label: total + '_days'
    });

    var start = fromHash();
    if (!dayAt(start)) start = firstOpenDay();
    show(start, false);
  }

  // Gate "Sign in": remember where to come back to. This is the only writer of
  // the cookie, so snippets/sdp-login-return.liquid only ever redirects customers
  // who started logging in from the program template. 30 min covers the
  // emailed-code login; an abandoned attempt is cleared on the next signed-out page.
  function bindLogin() {
    var btns = document.querySelectorAll('[data-sdpp-login]');
    for (var i = 0; i < btns.length; i++) {
      btns[i].addEventListener('click', function (e) {
        var path = e.currentTarget.getAttribute('data-sdpp-login') || window.location.pathname;
        document.cookie = 'sdpp_return=' + encodeURIComponent(path) + '; path=/; max-age=1800; SameSite=Lax';
      });
    }
  }

  function boot() {
    bindLogin();
    var roots = document.querySelectorAll('[data-sdpp]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
